module.exports = __webpack_public_path__ + "static/media/redis.a3ac72e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/redis.png
// module id = 179
// module chunks = 0